/**
 * MAWJ — Contact event tracking
 *
 * The main theme-level pixels were removed to avoid duplicate PageViews
 * (Custom Pixels handle the full funnel). This file handles ONLY the Contact
 * event fired when a visitor clicks a WhatsApp / phone / email link.
 *
 * Architecture:
 *  - Initializes Meta (fbq) and TikTok (ttq) SDKs WITHOUT firing PageView/page().
 *  - Listens for clicks on wa.me, tel:, and mailto: links.
 *  - Fires fbq('track','Contact') + ttq.track('Contact') on click.
 *
 * First-party routing:
 *  - Meta  → metrics.mawjgifts.com   (Stape DNS proxy)
 *  - TikTok → tiktok.mawjgifts.com  (Stape DNS proxy)
 */
(function () {
  'use strict';

  var META_ID = '2538847929835886';
  var TIKTOK_ID = 'D2BT263C77U3NVKITFNG';

  /* ── Meta Pixel (init only, no PageView) ─────────────────────── */
  if (!window.fbq) {
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e); t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://metrics.mawjgifts.com/en_US/fbevents.js');
    fbq('init', META_ID);
    /* PageView fired by Shopify Custom Pixel — not here to avoid duplication */
  }

  /* ── TikTok Pixel (init only, no page()) ─────────────────────── */
  if (!window.ttq) {
    !function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = w[t] = w[t] || [];
      ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent'];
      ttq.setAndDefer = function (t, e) {
        t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); };
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) {
        for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
        return e;
      };
      ttq.load = function (a, e) {
        var n = 'https://tiktok.mawjgifts.com/load/data.js';
        var o = document.createElement('script'); o.type = 'text/javascript'; o.async = !0;
        o.src = n + '?sdkid=' + a + '&lib=' + t;
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(o, s);
        ttq._i = ttq._i || {}; ttq._i[a] = []; ttq._i[a]._u = n;
        ttq._t = ttq._t || {}; ttq._t[a] = +new Date();
        ttq._o = ttq._o || {}; ttq._o[a] = e || {};
      };
      w[t] = ttq;
    }(window, document, 'ttq');
    ttq.load(TIKTOK_ID);
    /* ttq.page() fired by Shopify Custom Pixel — not here to avoid duplication.
       With "enhanced data postback" OFF, this pixel no longer auto-fires a
       duplicate PageView; it is used only for the explicit Contact event below. */
  }

  /* ── Contact click listener ───────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var el = e.target;
    /* walk up to find the anchor */
    while (el && el.tagName !== 'A') el = el.parentElement;
    if (!el) return;

    var href = el.getAttribute('href') || '';
    var isContact = (
      href.indexOf('wa.me') !== -1 ||
      href.indexOf('whatsapp') !== -1 ||
      href.slice(0, 4) === 'tel:' ||
      href.slice(0, 7) === 'mailto:'
    );
    if (!isContact) return;

    /* Fire Contact at most once per visit — one visitor = one chat intent.
       Prevents inflated conversions from a single user clicking multiple
       WhatsApp buttons (top / floating / end-of-page). */
    try {
      if (sessionStorage.getItem('mawj_contact_fired') === '1') return;
      sessionStorage.setItem('mawj_contact_fired', '1');
    } catch (e) { /* private mode — fall through and still fire once below */ }

    var _eid = 'contact_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7);
    if (window.fbq) fbq('track', 'Contact', {}, { eventID: _eid });
    if (window.ttq) ttq.track('Contact', { content_name: 'WhatsApp Click', value: 125, currency: 'AED' });
  }, true); /* capture phase so we catch it before navigation */

})();
